const GTMDataLayer = (props) => {
  if (window.dataLayer) {
    const event = window.dataLayer.find((element) => { return element.event === props.event });

    if (event && props.event == 'incentives_start') {
      null;
    }
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(props);
    }
  }
};

export default GTMDataLayer;